import { render, staticRenderFns } from "./NuevaInstitucionExterna.vue?vue&type=template&id=b2a1b6a4"
import script from "./NuevaInstitucionExterna.vue?vue&type=script&lang=js"
export * from "./NuevaInstitucionExterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports